import { useQuery } from '@tanstack/react-query';
import { fetchInspections } from '../lib/apiClient';
import { formatDistanceToNow } from '../lib/time';
import { useAuth } from '../lib/auth';

export function ActivityPage(): JSX.Element {
  const { user } = useAuth();
  const { data: inspections = [], isLoading } = useQuery({
    queryKey: ['activity', user?.organizationId],
    queryFn: () => fetchInspections({}),
    enabled: Boolean(user)
  });

  return (
    <div className="space-y-6">
      <header className="glass-card p-6">
        <h2 className="text-xl font-semibold text-foreground">Activity feed</h2>
        <p className="text-sm text-muted-foreground">Track uploads, AI summaries, and exports across your organization.</p>
      </header>

      <section className="glass-card divide-y divide-white/10">
        {isLoading && <div className="h-24 animate-pulse" />}
        {!isLoading &&
          inspections.map((inspection) => (
            <article key={inspection._id} className="flex flex-col gap-2 px-6 py-5 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <p className="text-sm font-medium text-foreground">
                  AI analysis {inspection.aiSummary ? 'completed' : 'pending'} for
                  {typeof inspection.propertyId === 'string' ? ` #${inspection._id.slice(-4)}` : ` ${inspection.propertyId.name}`}
                </p>
                <p className="text-xs text-muted-foreground">
                  {inspection.rooms.length} rooms • status {inspection.status}
                </p>
              </div>
              <div className="flex items-center gap-3 text-xs text-muted-foreground">
                <span>{formatDistanceToNow(inspection.updatedAt)}</span>
                <span className="rounded-full bg-muted px-2 py-1">{inspection.status}</span>
              </div>
            </article>
          ))}

        {!isLoading && inspections.length === 0 && (
          <div className="p-6 text-sm text-muted-foreground">No activity recorded yet. Run an inspection to populate this feed.</div>
        )}
      </section>
    </div>
  );
}
